import React from 'react'
import { LanguageSwitcher } from '../../components/common/LanguageSwitcher'
import './Auth.css'

interface AuthLayoutProps {
  children: React.ReactNode
}

/**
 * AuthLayout Component
 * Wrapper layout for authentication pages
 * Provides consistent styling and structure
 */
export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="auth-layout">
      <div className="auth-layout__language-switcher">
        <LanguageSwitcher />
      </div>
      <div className="auth-layout__container">
        <div className="auth-layout__header">
          <h1 className="auth-layout__logo">Ijro tizimi</h1>
          <p className="auth-layout__tagline">
            Bolalar kontentlarini rivojlantrish markazi
          </p>
        </div>

        <div className="auth-layout__content">{children}</div>

        <div className="auth-layout__footer">
          <p>
            &copy; {new Date().getFullYear()} Bolalar kontentlarini
            rivojlantrish markazi. Barcha huquqlar ximoyalangan.
          </p>
        </div>
      </div>
    </div>
  )
}
